/*
  Add here your own custom javascript codes
*/
document.addEventListener('DOMContentLoaded', function () {

  if (window.innerWidth <= 991) {
    document.querySelectorAll('.dropdown-submenu > .dropdown-toggle')
      .forEach(function (toggle) {

        toggle.addEventListener('click', function (e) {
          e.preventDefault();

          const parent = this.parentElement;

          // close other open submenus
          parent.parentElement
            .querySelectorAll('.dropdown-submenu.open')
            .forEach(function (el) {
              if (el !== parent) el.classList.remove('open');
            });

          parent.classList.toggle('open');
        });

      });
  }

});
